var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRelatorio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 84,
    viewBox: "0 0 75 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3334 46.4424H66.446C68.1849 46.3984 69.8378 45.6768 71.0521 44.4313C72.2664 43.1859 72.9461 41.5152 72.9461 39.7758C72.9461 38.0363 72.2664 36.3657 71.0521 35.1202C69.8378 33.8748 68.1849 33.1531 66.446 33.1091H62.0001C60.232 33.1091 58.5363 32.4067 57.286 31.1565C56.0358 29.9062 55.3334 28.2105 55.3334 26.4424C55.3334 24.6743 56.0358 22.9786 57.286 21.7284C58.5363 20.4781 60.232 19.7758 62.0001 19.7758H73.1126M37.5564 37.555H19.7793M64.223 19.7758V15.332M64.223 50.8883V46.4424M37.5564 55.332H19.7793",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4459 2H6.44587C5.86213 1.99972 5.28405 2.11445 4.74467 2.33765C4.20528 2.56084 3.71516 2.88812 3.30229 3.30079C2.88943 3.71345 2.56191 4.20342 2.33846 4.7427C2.11501 5.28198 2 5.86 2 6.44373V82L12.4 77.5563L22.7573 82L33.1125 77.5563L43.4677 82L53.8229 77.5563L64.2229 82V68.6667",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRelatorio);
export default __webpack_public_path__ + "static/media/icon_relatorio.10a45cc793db29af9092c1a3cb88cd41.svg";
export { ForwardRef as ReactComponent };